/* Presentation only: submit through the existing product form and preserve its gates. */
(() => {
  if (window.BMProductStandard) return;
  const instances = new Map();
  const text = (node, value) => { if (node && node.textContent !== String(value)) node.textContent = value; };
  class ProductStandard {
    constructor(root) {
      this.root = root;
      this.config = JSON.parse(root.querySelector('[data-bms-config]').textContent);
      this.info = root.querySelector('.product__info-container');
      this.layout = root.querySelector('.product');
      if (!this.info || !this.layout) return;
      root.classList.add('bms-product');
      root.dataset.bmsSingle = String(this.config.variantCount === 1);
      root.dataset.bmsCountry = this.config.country;
      document.body.classList.add('bms-page');
      this.dock = this.clone('[data-bms-dock-template]');
      document.body.append(this.dock);
      this.tax = this.clone('[data-bms-tax-template]');
      this.info.append(this.tax);
      const included = this.clone('[data-bms-included-template]');
      if (included) root.querySelector('.product__media-wrapper')?.append(included);
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); }); };
      // Keep the native machine accessories beside its form only on small screens.
      this.mobileLayout = matchMedia('(max-width:767px)');
      this.mobileLayout.addEventListener('change', this.schedule);
      this.onClick = event => {
        const link = event.target.closest('.bms-accessories-heading');
        if (!link || !this.extras) return;
        event.preventDefault();
        this.extras.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        this.extras.focus({preventScroll:true});
        history.replaceState(history.state,'',link.hash);
      };
      root.addEventListener('click', this.onClick);
      this.dock.querySelector('.bms-dock-buy').addEventListener('click', () => {
        this.sync();
        if (this.dock.querySelector('.bms-dock-buy').disabled) return;
        const buy = this.buy();
        if (buy) buy.click();
      });
      this.dock.querySelector('.bms-dock-summary').addEventListener('click', () => {
        const target = root.querySelector('variant-selects') || this.buy();
        target?.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        (target?.querySelector('input:checked,select') || this.buy())?.focus({preventScroll:true});
      });
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-busy','class','hidden','value','data-state']});
      document.addEventListener('spx:vat:ready',this.schedule);
      document.addEventListener('spx:vat:change',this.schedule);
      this.discovery = new MutationObserver(() => { if (!this.addons) this.adoptExtras(); });
      this.discovery.observe(document.body,{subtree:true,childList:true});
      this.adoptExtras(); this.sync();
    }
    t(key, params={}) { let value = this.config.messages[key] || ''; for (const [k,v] of Object.entries(params)) value = value.split(`{${k}}`).join(v); return value; }
    clone(selector) { return this.root.querySelector(selector)?.content.firstElementChild.cloneNode(true); }
    buy() { return this.root.querySelector('product-form .product-form__submit'); }
    adoptExtras() {
      if (this.addons) return;
      const addons = document.querySelector('[data-gm2ax]');
      if (!addons || document.querySelector('bm-gm3-configurator')) return;
      this.addons = addons;
      this.extras = this.root.querySelector('[data-bms-extras-slot]') || document.createElement('section');
      this.extras.className = 'bms-extras'; this.extras.id = 'bms-extras-'+this.root.dataset.section;
      this.extras.tabIndex=-1; this.extras.setAttribute('aria-label',this.t('complete_setup'));
      if (!this.extras.isConnected) this.layout.after(this.extras); this.extras.hidden=false; this.extras.append(addons);
      if(addons.dataset.careOnly==='true') { this.extras.classList.add('bms-care-only');this.info.append(this.extras);this.discovery?.disconnect();this.schedule?.();return; }
      this.accessoryStep=this.clone('[data-bms-accessories-template]');this.info.append(this.accessoryStep);
      this.accessoryStep.querySelector('.bms-offer').hidden=addons.dataset.accDisc!=='true';
      this.discovery?.disconnect(); this.schedule?.();
    }
    placeMobileExtras() {
      if (!this.extras || this.addons?.dataset.careOnly === 'true' || !/\/speediance-gym-monster-(?:2-classic|ultra)(?:$|[/?])/.test(this.root.dataset.url || '')) return;
      const form = this.buy()?.closest('product-form');
      const slot = form?.parentElement;
      // Never insert checkboxes into the machine's form, duplicate them, or replace them.
      if (this.mobileLayout.matches && form && slot?.classList.contains('product__buy-buttons')) {
        if (!this.extrasHome) {
          this.extrasHome = document.createComment('Native machine accessories position');
          this.extras.before(this.extrasHome);
        }
        if (form.nextElementSibling !== this.extras) form.after(this.extras);
        this.root.dataset.bmMobileExtras = 'true';
      } else if (this.extrasHome?.isConnected) {
        if (this.extrasHome.nextSibling !== this.extras) this.extrasHome.after(this.extras);
        delete this.root.dataset.bmMobileExtras;
      }
    }
    sync() {
      if (!this.root.isConnected) return this.destroy();
      // Read rendered prices together before this sync changes the dock or product layout.
      const priceRoot=this.root.querySelector('[id^="price-"]');
      const visible=e=>e.getClientRects().length&&getComputedStyle(e).visibility!=='hidden';
      const price=[...(priceRoot?.querySelectorAll('.price-item--sale')||[]),...(priceRoot?.querySelectorAll('.price__regular .price-item')||[])].find(visible);
      const was=[...(priceRoot?.querySelectorAll('.price__sale s.price-item--regular')||[])].find(visible);
      const priceText=price?.textContent.trim()||'',wasText=was?.textContent.trim()||'';
      this.placeMobileExtras();
      for(const legend of this.root.querySelectorAll('variant-selects legend')) {
        const name=legend.textContent.trim();
        if(/^(version|model|modèle|modell|modelo|versie)$/i.test(name)){ text(legend,this.t('choose_model'));legend.closest('fieldset').dataset.bmsModel='true'; }
        else if(/^(accessories|package|accessoires|zubehör|pakket)$/i.test(name)) text(legend,this.t('choose_package'));
      }
      const buy=this.buy(), dockBuy=this.dock.querySelector('.bms-dock-buy');
      const busy=!!buy && (buy.classList.contains('loading')||buy.getAttribute('aria-disabled')==='true'||buy.getAttribute('aria-busy')==='true');
      dockBuy.disabled=!buy||buy.disabled||busy;
      dockBuy.setAttribute('aria-busy',String(busy));
      text(dockBuy,busy?this.t('adding'):(buy?.querySelector('span')?.textContent.trim()||buy?.textContent.trim()||this.t('sold_out')));
      text(this.dock.querySelector('[data-bms-price]'),priceText);
      // bm-cap-20260928: mirror the struck was-price into the dock.
      const dockWas=this.dock.querySelector('[data-bms-compare]');if(dockWas){text(dockWas,wasText);dockWas.hidden=!dockWas.textContent;}
      const selected=this.root.querySelector('variant-selects [data-selected-variant]');let variant;
      try {variant=selected&&JSON.parse(selected.textContent);}catch{}
      text(this.dock.querySelector('[data-bms-summary]'),[this.config.title.replace(/^Speediance\s+/,''),variant?.title!=='Default Title'?variant?.title:''].filter(Boolean).join(' · '));
      const vat=window.SPXVat,country=this.config.country;
      const term=['AU','NZ'].includes(country)?'GST':country==='CH'&&/^de/i.test(this.config.locale)?'MWST':this.t('vat');
      const taxLabel=country==='CH'?this.t('swiss_excluded',{tax:term}):vat?.available?this.t(vat.enabled?'tax_including_rate':'tax_excluding_checkout',{tax:term,rate:vat.rate}):this.t(this.config.taxesIncluded?'tax_included':'tax_checkout');
      text(this.tax.querySelector('[data-bms-tax]'),taxLabel);
      text(this.dock.querySelector('[data-bms-tax-short]'),country==='CH'?this.t('tax_excluding_short',{tax:term}):vat?.available?this.t(vat.enabled?'tax_including_short':'tax_excluding_short',{tax:term}):this.config.taxesIncluded?this.t('tax_included_short'):'');
      const vatRoot=this.root.querySelector('vat-calculator');
      if(vatRoot){text(vatRoot.querySelector('.vat__info-popover'),this.config.taxHelp);vatRoot.querySelector('.vat__info-trigger')?.setAttribute('aria-label',this.config.taxInformation);const labels=vatRoot.querySelectorAll('.vat__text');text(labels[0],this.t('tax_excluding_short',{tax:term}));text(labels[1],this.t('tax_including_short',{tax:term}));text(vatRoot.querySelector('.toggle .visually-hidden'),this.t('tax_including_short',{tax:term}));}
      if(this.addons){const count=this.addons.querySelector('.gm2ax__count'),summary=this.dock.querySelector('[data-bms-extras-summary]');text(summary,count?.textContent.trim()||'');summary.hidden=!summary.textContent;}
    }
    destroy() { this.mobileLayout?.removeEventListener('change',this.schedule);this.extrasHome?.remove();this.observer?.disconnect();this.discovery?.disconnect();cancelAnimationFrame(this.frame);this.dock?.remove();this.root.removeEventListener('click',this.onClick);document.removeEventListener('spx:vat:ready',this.schedule);document.removeEventListener('spx:vat:change',this.schedule);instances.delete(this.root);if(!instances.size)document.body.classList.remove('bms-page'); }
  }
  const boot=()=>{for(const [root,instance]of instances)if(!root.isConnected)instance.destroy();document.querySelectorAll('product-info:has([data-bms-config])').forEach(root=>{if(!instances.has(root)){try{instances.set(root,new ProductStandard(root));}catch(error){console.error('[product-standard]',error);}}});};
  window.BMProductStandard={boot};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('product-info:loaded',()=>queueMicrotask(boot));
})();
